export const svgCoord = (x: number) => x.toFixed(4);
